function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.81 21.62C16.7802 21.62 21.62 16.7802 21.62 10.81C21.62 4.8398 16.7802 0 10.81 0C4.8398 0 0 4.8398 0 10.81C0 16.7802 4.8398 21.62 10.81 21.62Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8594 10.0599V8.05994C15.482 8.08725 15.103 8.03751 14.7454 7.91373C14.3878 7.78996 14.0592 7.59473 13.7795 7.33994C13.3107 6.7779 13.0494 6.07176 13.0395 5.33994V5.18994H11.1895V13.1899C11.1303 13.5276 10.972 13.8401 10.7349 14.0877C10.4978 14.3353 10.1925 14.5069 9.85773 14.5807C9.52294 14.6545 9.17377 14.6271 8.85455 14.5021C8.53534 14.3771 8.26053 14.16 8.06488 13.8785C7.86923 13.597 7.76157 13.2637 7.75568 12.921C7.74978 12.5782 7.84594 12.2414 8.0318 11.9533C8.21766 11.6652 8.48489 11.4389 8.79962 11.303C9.11435 11.1671 9.46237 11.1277 9.7995 11.1899L10.0694 11.2699V9.36994C9.87301 9.35504 9.67582 9.35504 9.47943 9.36994C8.77137 9.36994 8.07927 9.57991 7.49054 9.97328C6.90181 10.3667 6.4429 10.9258 6.17194 11.5799C5.90097 12.2341 5.83007 12.9539 5.9682 13.6484C6.10634 14.3428 6.44739 14.9807 6.94806 15.4814C7.44873 15.9821 8.08662 16.323 8.78107 16.4612C9.47552 16.5993 10.1953 16.5284 10.8494 16.2574C11.5036 15.9865 12.0627 15.5276 12.4561 14.9389C12.8495 14.3502 13.0595 13.658 13.0595 12.9499C13.0698 12.8035 13.0698 12.6564 13.0595 12.5099V9.30994C13.8983 9.83094 14.8725 10.0919 15.8594 10.0599Z",
  fill: "black"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.61,
  height: 21.61,
  fill: "white"
})));
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c20aa4af.svg";
export { ForwardRef as ReactComponent };